module.exports = __webpack_public_path__ + "img/jaoc_pop_results_correct.516a65be.png";